import { ReactComponent as ChallanReceiptIcon } from "../../../assets/icons/challan_receipt.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/download-icon.svg";
import { ReactComponent as PaymentIcon } from "../../../assets/icons/payment_icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/editIconGrey.svg";
import { ReactComponent as PrintIcon } from "../../../assets/icons/print_icon.svg";
import { calculateTotalOutstanding } from "../../../database/helpers/customer";
import { bulkUpdateStockV2 } from "../../../database/helpers/stock";
import { getInvoiceByID } from "../../../database/helpers/invoice";
import { validate } from "../../../validations/index";
import { analytics, triggerLogEvent } from "../../../config/firebase";

import { toast } from "react-toastify";
import {
  handleBusinessReportUrl,
  postDownloadPDF,
  Sync,
} from "../../../SyncService";
import {
  PaymentMethods,
  handleToast,
  roundToTwoDp,
  REPORT_URL,
  uuid,
  SEVERITY,
} from "../../../constants";
import {
  bulkCreatePayments,
  getPaymentsByInvoiceExternal,
} from "../../../database/helpers/payment";
import {
  bulkUpdateTransactionStock,
  bulkCreateOrdersV3,
  bulkDeleteOrders,
  bulkRestoreStock,
  bulkUpdateOrders,
} from "../../../database/helpers/orders";
import { removeRsFromValue } from "../../../utils";
import { handleApi } from "../../../apis";
import { PDF_DOWNLOAD, POST_PAYMENT_REQUEST } from "../../../apis/configuration";
import fileDownload from "js-file-download";

export const itemValueLimit = 999999;
export const ACTION_NAMES = {
  DOWNLOAD_INVOICE: "Download invoice PDF",
  EDIT_INVOICE: "Edit invoice",
};
export const Actions = [
  {
    label: (
      <div>
        {" "}
        <EditIcon />
        {ACTION_NAMES.EDIT_INVOICE}
      </div>
    ),
    hideOnPaid: true,
  },
  {
    label: (
      <div>
        {" "}
        <ChallanReceiptIcon /> Delivery challan
      </div>
    ),
    action: (e, setComingSoon) => {
      e.stopPropagation();
      handleToast(setComingSoon);
    },
  },
  {
    label: (
      <div>
        {" "}
        <PaymentIcon /> Record payment
      </div>
    ),
    action: (e, setComingSoon, showRecordPayment, handleClose) => {
      // handleClose();
      if (showRecordPayment && typeof showRecordPayment === "function") {
        showRecordPayment(e.currentTarget);
      }
    },
    hideOnPaid: true,
  },
  {
    label: (
      <div>
        {" "}
        <PrintIcon /> Print
      </div>
    ),
    action: (e, setComingSoon) => handleToast(setComingSoon),
  },
  {
    label: (
      <div>
        {" "}
        <DownloadIcon id="download_black_btn" /> {ACTION_NAMES.DOWNLOAD_INVOICE}
      </div>
    ),
  },
];
export const handleSendReminder = async (
  cb_id,
  customer,
  toastCallback,
  editPhoneCallback,
  I18n,
  navigate,
) => {
  if (navigator.onLine) {
    if (
      customer &&
      (customer.total_outstanding_payment > 10000 ||
        customer.total_outstanding_payment < 50)
    ) {
      // MAX LIMIT
      toastCallback(
        "Payment should be between Rs.50 and Rs. 10,000",
        SEVERITY.ERROR,
      );
    } else {
      if (customer && customer.phone) {
        let params = {
          business_id: cb_id,
          customer_id: customer.id,
          amount: customer.total_outstanding_payment,
        };

        handleApi(POST_PAYMENT_REQUEST, params, null, navigate)
          .then((res) => {
            const { message_sent } = res;
            if (message_sent) {
              triggerLogEvent(analytics, "request_money_successful", {
                status: true,
              });
            }
            toastCallback(
              message_sent
                ? I18n.Request_Send_success
                : "Limit reached (1 request per day)",
              message_sent ? SEVERITY.SUCCESS : SEVERITY.ERROR,
            );
          })
          .catch((err) => {
          });
      } else {
        editPhoneCallback();
      }
    }
  } else {
    toastCallback(I18n.internet_connection_is_required, SEVERITY.ERROR);
  }
};

export const handleDeliveryChallan = async (successCallback) => {
  if (true && successCallback) {
    successCallback?.();
  }
};

export const formatDiscount = (amount = 0, type = "%") => {
  return type === "%" ? `${amount} ${type}` : `${type} ${amount}`;
};

export const checkInvoiceValidation = (InvoiceData) => {
  const isCustNumValid = InvoiceData?.CustomerDetails?.cPhone
    ? validate(
        InvoiceData?.CustomerDetails?.cPhone,
        /^03[0-9]{2}(?!1234567)(?!1111111)(?!7654321)[0-9]{7}$/,
      )
    : true;
  const customerValid = Boolean(
    isCustNumValid && InvoiceData?.CustomerDetails?.date,
  );
  const { BillDetails } = InvoiceData || {};
  const billValid =
    Number(BillDetails?.advance) >= 0 &&
    Number(BillDetails?.taxValue) >= 0 &&
    Number(BillDetails?.discValue) >= 0 &&
    Number(BillDetails?.discValue) <
      Number(Number(BillDetails.subT) ? BillDetails.subT : BillDetails.total) &&
    Number(BillDetails?.subT) >= 0 &&
    Number(BillDetails?.total) > 0;
  return billValid && customerValid;
};
export const calculateInvoiceProfit = (type = "in", invoiceItemList = []) => {
  let itemsProfit = 0;
  invoiceItemList.forEach((item) => {
    let salePrice = item?.hasOwnProperty("updated_selling_price")
      ? item.updated_selling_price
      : item?.price;
    let costPrice = item?.hasOwnProperty("updated_cost_price")
      ? item.updated_cost_price
      : type === "out"
        ? item.price
        : 0;
    let discountPrice = calculateItemDiscount(item);
    itemsProfit += (salePrice - costPrice) * item.qty - discountPrice;
  });
  return itemsProfit;
};
const handleCreateCustomerPayment = async (
  business,
  customer,
  data,
  invoice,
  type,
) => {
  let payObj = {
    date: data?.date || new Date(),
    note: data?.note || "",
    image_url: data?.image_url || "",
    type: "invoicebook",
  };

  let paymentArr = [
    {
      ...payObj,
      uid: uuid(),
      amount: data.amount,
      payment_mode: type == "in" ? "Udhaar" : "Jama",
      external_type: "full_invoice",
    },
  ];

  if (data?.advance_amount > 0) {
    paymentArr.unshift({
      ...payObj,
      uid: uuid(),
      amount: Number(data.advance_amount),
      payment_mode: type == "in" ? "Jama" : "Udhaar",
      external_type: "partial_invoice",
    });
  }

  await bulkCreatePayments(business, customer, invoice, paymentArr);

  let totalOutstanding = await calculateTotalOutstanding(customer);

  await customer.updateTotalOutstanding(totalOutstanding);
};

/**
 * @desc set prefix for new/existing users
 */
const handleInvoicePaymentMethod = async (data, createdInvoice) => {
  let { method, bank, wallet, advance_amount } = data;

  let params = {
    method: method || "cash",
    bank,
    wallet,
    amount: advance_amount,
  };

  let invPayments = await createdInvoice.invoice_payments.fetch();

  if (!invPayments.length) {
    await createdInvoice.createTransactionPayments(params);
  } else {
    await invPayments[0].updateInvPayment(params);
  }
};

// export const handleDownloadReport = (
//   business,
//   dateRange,
//   type,
//   handleLoader = (x) => { }
// ) => {
//   let paramsForReport = {
//     name: "invoice_statement.pdf",
//     template_name: "accountreport_new.hbs",
//     business_id: business.id,
//     start_date: dateRange[0] || "",
//     end_date: dateRange[1] || "",
//     type: "invoice",
//     invoice_type: type === "in" ? "sales" : "expense",
//     pdf: true,
//   };
//   postDownloadPDF(paramsForReport)
//     .then(() => {
//       toast.success("Report Downloaded!");
//     })
//     .catch((err) => {
//       toast("Error in Making Report" + err.toString());
//     });
// };
export const handleDownloadInvoice = async (inv, business, closeCallback, navigate, fileName = "Rupin Sale Invoice") => {
  try {
    let paramsForReport = {
      template_name: "invoicereport.hbs",
      name: `${fileName}.pdf`,
      invoice_id: inv.id,
      template_style: localStorage.getItem("invoiceStyle") || "style1",
      template_color: localStorage.getItem("invoiceColor") || "#000000",
      pdf: true,
    };

    let rep_url;
    if (localStorage.getItem("phone_number")) {

      if (business?.report_url) {
        rep_url = business?.report_url;
      } else {
        rep_url = await handleBusinessReportUrl(business,navigate);
      }
      paramsForReport["payment_link"] = `${REPORT_URL}/i/${rep_url}/${
        inv?.id?.split("-")[0]
      }`;
    }

    const response = await handleApi(
      PDF_DOWNLOAD,
      paramsForReport,
      null,
      navigate,
      null,
      { responseType: "blob" },
    );
    fileDownload(response, paramsForReport.name);
    closeCallback();
  } catch (error) {
    closeCallback(error);
  }
};

export const getConvertedDisountMehod = (disc_method) => {
  //To handle Same as Mobile App
  return disc_method === "%" ? disc_method : "rs";
};


export const calculateItemDiscount = (item, discountMehod = undefined) => {
  let discount = Number(item.discount) || 0;
  let salePrice = item?.updated_selling_price || item?.price;
  let discMethod = discountMehod || item.discount_method;
  let discountPrice = 0;
  if (discMethod == "%")
    discountPrice = (discount / 100) * salePrice * item.qty;
  else discountPrice = discount * item.qty;
  discountPrice = discountPrice || 0;
  return discountPrice;
};
export const handleKeyDown = (e, excludeList = []) => {
  let inputsToBlock = ["+", "-", ".", "e"];
  inputsToBlock = inputsToBlock.filter((inp) => !excludeList.includes(inp));
  if (inputsToBlock.includes(e.key)) {
    e.preventDefault();
  }
};
export const calculateItemAmount = (currentItem) => {
  let disc = currentItem?.discount ? Number(currentItem?.discount) : 0;
  const subtotal =
    (Number(currentItem?.price) || 0) * (Number(currentItem?.qty) || 0);
  let total_amt =
    currentItem?.discount_method === "%"
      ? subtotal * (1 - disc / 100)
      : subtotal - disc * Number(currentItem?.qty);
  return roundToTwoDp(total_amt);
};

export const handleUnitTabClick = (
  currentItem,
  unitOptions,
  successCallback,
  showSnackbar,
  I18n,
) => {
  if (currentItem.isNew || (currentItem.id && unitOptions.length)) {
    successCallback && successCallback();
  } else {
    if (!currentItem.id) {
      // toast.error("Please Enter Item name first!", {
      //   className: "errorToast",
      //   toastId: "err_unit_select",
      //   autoClose:100000000
      // });
      showSnackbar({
        message: I18n.please_enter_item_name_first,
        severity: "error",
      });
    } else {
      // toast.info("Only one unit for the selected item.", {
      //   className: "errorToast",
      //   toastId: "err_unit_select_item",
      // });
      showSnackbar({
        message: I18n.only_one_unit_for_the_selected_item,
        severity: "error",
      });
    }
  }
};

export const handleUnitSelect = (currItem, unitName, all_items, type) => {
  let itemUpdates = {
    updated_unit: unitName,
  };
  if (!currItem.isNew && currItem.id) {
    const stock_item = all_items.find((it) => it.id === currItem.id);
    if (stock_item) {
      if (stock_item.secondary_unit === unitName) {
        const sellingPrice = stock_item?.selling_price;
        const costPrice = stock_item?.cost_price;

        const updatedSellingPrice = roundToTwoDp(
          sellingPrice / (Number(stock_item?.unit_conversion) || 1),
        );

        const updatedCostPrice = roundToTwoDp(
          costPrice / (Number(stock_item?.unit_conversion) || 1),
        );

        itemUpdates = {
          ...itemUpdates,
          price: type === "in" ? updatedSellingPrice : updatedCostPrice,
          updated_selling_price: updatedSellingPrice,
          updated_cost_price: updatedCostPrice,
        };
      } else {
        const sellingPrice = stock_item?.selling_price;
        const costPrice = stock_item?.cost_price;
        const updatedPrice = roundToTwoDp(
          type === "in" ? sellingPrice : costPrice,
        );
        itemUpdates = {
          ...itemUpdates,
          price: updatedPrice,
          updated_selling_price: sellingPrice,
          updated_cost_price: costPrice,
        };
      }
    }
  }
  return itemUpdates;
};

export const handleItemNameClick = (item, type, discChosen = "Rs.") => {
  const OrderObj = {};
  OrderObj.id = item.id;
  OrderObj.name = item.name;
  OrderObj.unit = item?.unit;
  OrderObj.price =
    type === "in"
      ? roundToTwoDp(item?.selling_price)
      : roundToTwoDp(item?.cost_price);
  OrderObj.qty = 1;
  OrderObj.updated_selling_price = roundToTwoDp(item?.selling_price);
  OrderObj.discount_method = discChosen;
  OrderObj.discount = 0;
  OrderObj.updated_cost_price = roundToTwoDp(item?.cost_price);
  OrderObj.updated_unit = item?.unit;
  OrderObj.secondary_unit = item?.secondary_unit;
  OrderObj.unit_conversion = item?.unit_conversion;
  OrderObj.isNew = false;
  return OrderObj;
};
export const handleAddNewItem = (itemName, discChosen = "Rs.") => {
  const OrderObj = {};
  OrderObj.id = uuid();
  OrderObj.name = itemName;
  OrderObj.unit = "Pieces";
  OrderObj.price = 0;
  OrderObj.qty = 1;
  OrderObj.updated_selling_price = 0;
  OrderObj.discount_method = discChosen;
  OrderObj.discount = 0;
  OrderObj.updated_cost_price = 0;
  OrderObj.updated_unit = "Pieces";
  OrderObj.isNew = true;
  return OrderObj;
};

export const navigateToEdit = (navigate, type, data, location) => {
  let pathNametoChange = `/${
    type?.toLowerCase?.() === "out" ? "PurchaseInvoice" : "InvoiceBook"
  }/Edit`;
  navigate(pathNametoChange, {
    state: {
      pathname: location.pathname,
      data: data ?? {},
    },
  });
};

// export const getSignImage = (imgValue = "") => {
//   if (typeof imgValue === typeof "" && imgValue?.startsWith?.("https:/")) {
//     return imgValue;
//   }
//   if (imgValue instanceof Blob || imgValue instanceof File) {
//     return URL.createObjectURL(imgValue);
//   }
//   return "";
// };

export const getSignImage = (imgValue = "") => {
  if (!imgValue) return "";

  // If already full URL
  if (typeof imgValue === "string" && imgValue.startsWith("http")) {
    return imgValue;
  }

  // If already proper base64 format
  if (typeof imgValue === "string" && imgValue.startsWith("data:image")) {
    return imgValue;
  }

  // If raw base64 without prefix
  if (typeof imgValue === "string") {
    return `data:image/png;base64,${imgValue}`;
  }

  // If File or Blob
  if (imgValue instanceof Blob || imgValue instanceof File) {
    return URL.createObjectURL(imgValue);
  }

  return "";
};

export const getPaymentMethodType = (invoice) => {
  const method = invoice?.method;
  let medium;
  if (method?.toLowerCase() === "bank") {
    medium = invoice?.bank;
  } else if (method?.toLowerCase() === "wallet") {
    medium = invoice?.wallet;
  } else {
    if (method) medium = "cash";
  }
  if (medium) {
    let selectedMethod = PaymentMethods.find(
      (value) => value.name.toLowerCase() === medium?.toLowerCase?.(),
    );
    return selectedMethod || null;
  } else {
    return null;
  }
};



const updateInvoiceData = async (
  invoice,
  data,
  user,
  handleClose,
  navigate,
) => {
  invoice.updateInvocie(data).then(async () => {
    toast.success("Invoice updated", {
      className: "successToast",
    });
    handleClose();
    await Sync(user.phone_number, navigate)
      .then((x) => {})
      .catch((err) => {
      });
  });
};

const handleEditTransactionItems = async (
  business,
  invoice,
  orders,
  type,
  items,
) => {
  const selectedItems = Object.values(items);
  let toAdd = [],
    toEdit = [],
    toDelete = [];

  let orderMap = {};

  await Promise.all(
    orders.map(async (x) => {
      if (items[x.stock.id]) {
        toEdit.push({ original: x, updated: items[x.stock.id] });
      } else {
        let stock = await x.stock.fetch();
        toDelete.push({ original: x, updated: stock });
      }

      orderMap[x.stock.id] = x;
    }),
  );
  selectedItems.map((x) => {
    if (!orderMap[x.id]) toAdd.push(x);
  });
  if (toAdd.length) {
    await bulkCreateOrdersV3(business, invoice, toAdd, type, "invoice");
    await bulkUpdateStockV2(toAdd, type);
  }

  if (toEdit.length) {
    await bulkUpdateTransactionStock(toEdit, type);
    await bulkUpdateOrders(toEdit, true);
  }

  if (toDelete.length) {
    await bulkRestoreStock(toDelete, type);
    await bulkDeleteOrders(toDelete);
  }
};
